import { render, staticRenderFns } from "./ModalNewSubPlot.vue?vue&type=template&id=33a59528"
import script from "./ModalNewSubPlot.vue?vue&type=script&lang=js"
export * from "./ModalNewSubPlot.vue?vue&type=script&lang=js"
import style0 from "./ModalNewSubPlot.vue?vue&type=style&index=0&id=33a59528&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a59528')) {
      api.createRecord('33a59528', component.options)
    } else {
      api.reload('33a59528', component.options)
    }
    module.hot.accept("./ModalNewSubPlot.vue?vue&type=template&id=33a59528", function () {
      api.rerender('33a59528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ModalNewSubPlot.vue"
export default component.exports